'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _mobx = require('mobx');

var _index = require('./ui/index');

var _index2 = _interopRequireDefault(_index);

var _urlHelper = require('./url-helper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var escapeName = function escapeName(name) {
  return name.replace(/\./g, '-');
};

var DevNovel = (_class = function () {
  function DevNovel() {
    _classCallCheck(this, DevNovel);

    _initDefineProp(this, 'openAllStories', _descriptor, this);

    _initDefineProp(this, 'project', _descriptor2, this);

    this.initializers = [];
    this.disposers = [];
    this.stories = {};
    this.isFirstRun = true;

    _initDefineProp(this, 'selectedStory', _descriptor3, this);

    _initDefineProp(this, 'actionLogs', _descriptor4, this);
  }

  // inner state


  _createClass(DevNovel, [{
    key: 'applyOpts',
    value: function applyOpts(opts) {
      var _opts$openAllStories = opts.openAllStories,
          openAllStories = _opts$openAllStories === undefined ? false : _opts$openAllStories,
          _opts$projectName = opts.projectName,
          projectName = _opts$projectName === undefined ? 'devnovel' : _opts$projectName,
          _opts$projectLink = opts.projectLink,
          projectLink = _opts$projectLink === undefined ? '/' : _opts$projectLink;

      this.openAllStories = openAllStories;
      this.project.name = projectName;
      this.project.link = projectLink;
    }
  }, {
    key: 'add',
    value: function add(parentName) {
      var _this = this;

      return function (storyName, fn) {
        if (typeof (0, _get2.default)(_this.stories, parentName + '.' + storyName) === 'function') {
          throw new Error('story: ' + storyName + ' is already defined');
        }

        if (!(0, _isString2.default)(storyName) && typeof fn !== 'function') {
          throw new Error('usage: `add(storyName: string, fn: Function)`');
        }

        // remove `.` from keys or `_.get` wont work as expected
        var safeParentName = escapeName(parentName);
        var safeStoryName = escapeName(storyName);

        Object.assign(_this.stories, _defineProperty({}, safeParentName, _extends({}, _this.stories[safeParentName] || {}, _defineProperty({}, safeStoryName, fn))));

        return _this._bindedInstance({ parentName: parentName });
      };
    }

    // * empty story container
    // * clear old action logs
    // * load story render fn

  }, {
    key: 'loadSelectedStory',
    value: function loadSelectedStory() {
      if (this.isFirstRun) {
        this.isFirstRun = false;
      } else {
        this.disposers.forEach(function (disposer) {
          return disposer();
        });
        this.actionLogs.clear();
        this.emptyStoryContainer();
      }

      this.initializers.forEach(function (initializer) {
        return initializer();
      });

      var fn = (0, _get2.default)(this.stories, this.selectedStory);
      fn(this.storyContainer);
      (0, _urlHelper.updateURL)(this.selectedStory);
    }
  }, {
    key: 'initSelectedStory',
    value: function initSelectedStory() {
      var selectedStoryFromURL = (0, _urlHelper.loadFromURL)();
      if (selectedStoryFromURL && (0, _get2.default)(this.stories, selectedStoryFromURL)) {
        this.selectedStory = selectedStoryFromURL;
      } else {
        var firstParent = Object.keys(this.stories)[0];
        this.selectedStory = firstParent + '.' + Object.keys(this.stories[firstParent])[0];
      }
    }
  }, {
    key: 'selectParent',
    value: function selectParent(parentName) {
      // update selected story
      var safeParentName = escapeName(parentName);

      var _Object$keys = Object.keys(this.stories[safeParentName]),
          _Object$keys2 = _slicedToArray(_Object$keys, 1),
          firstStoryOfParent = _Object$keys2[0];

      this.selectedStory = safeParentName + '.' + firstStoryOfParent;
      this.loadSelectedStory();
    }
  }, {
    key: 'selectStory',
    value: function selectStory(selectedStory) {
      this.selectedStory = selectedStory;
      this.loadSelectedStory();
    }
  }, {
    key: 'emptyStoryContainer',
    value: function emptyStoryContainer() {
      this.storyContainer.innerHTML = '';
    }
  }, {
    key: 'injectUI',
    value: function injectUI() {
      (0, _index.baseStyles)();

      var container = window.document.createElement('div');
      window.document.body.appendChild(container);
      (0, _reactDom.render)(_react2.default.createElement(_index2.default, { devNovelInstance: this }), container);
    }
  }, {
    key: '_bindedInstance',
    value: function _bindedInstance(opts) {
      return {
        add: this.add(opts.parentName)
      };
    }
  }, {
    key: 'storyContainer',
    get: function get() {
      return window.document.getElementById('story-container');
    }
  }]);

  return DevNovel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'openAllStories', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'project', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      name: 'dev novel',
      link: '/'
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'selectedStory', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return undefined;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'actionLogs', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'initSelectedStory', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'initSelectedStory'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectParent', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'selectParent'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectStory', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'selectStory'), _class.prototype)), _class);
exports.default = DevNovel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dev-novel/dist/dev-novel.js
// module id = 301
// module chunks = 0